import { FaCheck } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import { useSelector } from 'react-redux';
import { useState } from 'react';
import axios from 'axios';
import { TailSpin } from 'react-loader-spinner';
import ModalCompManagerVacations from '../ModalCompManagerVacations/ModalCompManagerVacations';
import { useNavigate } from 'react-router-dom';
import { errorHandeling } from '../../../errorHandeling';
import apiUrl from '../../../libs/baseUrl';
import { formatDate, getTheHoursAndMinutes } from "../../../libs/generalFunctions";
import handleGetFullEmpName from "../../../libs/getFullName";

import './showManagerVacationsComp.scss';


function ShowManagerVacationsComp({fetchVacations,vacationsArr,showMore}) {

const navigate = useNavigate();

const token = useSelector(state => state.user.token)

const authMe = useSelector(state => state.authme.data);

//====State start here====
const [loadingChanges,setLoadingChanges] = useState(false);

const [loadingElementId,setLoadingElementId] = useState(-1);

const [error,setError] = useState(null);

//to try to make a modal
const [modalIsOpen, setIsOpen] = useState(false);

const [modalData,setModalData] = useState({})

//====State end here====
  
//====Event handler start here====

  function openModal(obj) {
    setModalData(obj)
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }


let handelAcceptVacation = async(vacationId,empJobId)=>{

  setLoadingElementId(vacationId);

  if(authMe?.is_manager ){
 

 const data = {
  status : 1,
  job_id : empJobId,

 }

  try {
      setLoadingChanges(true)
      const response = await axios.put(`${apiUrl}/vacations/${vacationId}/change-status`,data, {
          headers: {
              Authorization: `Bearer ${token}`
          }
      });

      setLoadingChanges(false);
      fetchVacations();
      
  } catch (error) {
      console.error("Error fetching department data:", error);
      setLoadingChanges(false);
      setError(errorHandeling(error));
  }


}


}

let handelRefuceVacation = async(vacationId,empJobId)=>{

  setLoadingElementId(vacationId);
 
  if(authMe?.is_manager ){
  const data = {
   status : 0,
   job_id : empJobId,

  }
 
   try {
       setLoadingChanges(true)
       const response = await axios.put(`${apiUrl}/vacations/${vacationId}/change-status`,data, {
           headers: {
               Authorization: `Bearer ${token}`
           }
       });

       setLoadingChanges(false)
       fetchVacations();
       
   } catch (error) {
       console.error("Error fetching department data:", error);
       setLoadingChanges(false)
       setError(errorHandeling(error))
   }
 
 
 }

}


  //show the vacation endtime and starttime
  const vacatoinTimeShow = (obj,timeType)=>{
   if(timeType === "end_time"){
 
   if(obj.type === "EXIT_PERMISSION" ){
     return (
      <div style={{display:"flex",flexDirection:"column"}}>
        <span>{ obj?.start_date && formatDate(obj.start_date) }</span>
        <span>({getTheHoursAndMinutes(obj.start_date)})</span>
      </div>
     );
   }
   else if(obj.type === "MISSION"){
    return (
      <div style={{display:"flex",flexDirection:"column"}}>
        <span>{ obj?.end_date && formatDate(obj.end_date)}</span>
        <span>({getTheHoursAndMinutes(obj.end_date)})</span>
      </div>
     );
   }
   else{
    return formatDate(obj.end_date);
   }
  }
  else if(timeType === "start_time"){
 
    if(obj.type === "EXIT_PERMISSION" ){
      return (
       <div style={{display:"flex",flexDirection:"column"}}>
         <span>{ obj?.start_date && formatDate(obj.start_date) }</span>
         <span>({getTheHoursAndMinutes(obj.start_date)})</span>
       </div>
      );
    }
    else if(obj.type === "MISSION"){
     return (
       <div style={{display:"flex",flexDirection:"column"}}>
         <span>{ obj?.start_date && formatDate(obj.start_date) }</span>
         <span>({getTheHoursAndMinutes(obj.start_date)})</span>
       </div>
      );
    }
    else{
     return formatDate(obj.start_date);
    }
   }
  }


//handling showing more of vacations for the manager
 const handleShowMoreClicked = ()=>{
  navigate("/emp/vacationmang");
 }

//====Event handler end here==== 

  return (
    <div className='ShowManagerVacationsComp'>


    <div className="vacationManagerShow_content">
        <span className="vacationManagerShow_title" dir="rtl">طلبات الاجازة</span>

        {
          ( error ) 
          ?
          ( <span className='error_in_saving' style={{ color: 'red'}} dir='rtl' >{error}</span> )
          :
          ( <></> )
        }
        
        <table className='vacationManagerShow_table'>
        <thead>
        <tr className='vacationManagerShow_header_row_table'>
          <th>خيارات</th>
          <th>تفاصيل</th>
          <th>تاريخ النهاية</th>
          <th>تاريخ البداية</th>
          <th>الاسم</th>
          <th>الرقم الوظيفي</th>
        </tr>
        </thead>


    <tbody>

          { vacationsArr?.map(
            obj =>(
              <tr  key={obj.id}>
              <td>
            <div className='vacationManagerShow_table_choices'>
            {
             ( loadingChanges  ) &&  (obj.id === loadingElementId) ?
               <div className='spinner_getData'>
               <TailSpin
               visible={true}
               height="20"
               width="20"
               color="rgb(246,229,56)"
               ariaLabel="tail-spin-loading"
               radius="1"
               wrapperStyle={{}}
               wrapperClass=""
                 />
               </div>
          :
         <>
              <button onClick={()=>{handelRefuceVacation(obj.id,obj.employee?.job_id)}} disabled={loadingChanges }>
              <MdOutlineCancel className='vacationManagerShow_btn_cancel' />
              </button>
        
              <button onClick={()=>{handelAcceptVacation(obj.id,obj.employee?.job_id)}} disabled={loadingChanges }>
              <FaCheck className='vacationManagerShow_btn_accept'   />
              </button>
         
         </>
        }

            </div>
           </td>
           <td dir="rtl">
              <div className='btn_for_VacaMoreDetails_cover'>
                <button className='btn_for_VacaMoreDetails' onClick={()=>{openModal(obj)}}>عرض</button>
              </div>
           </td> 
           <td dir="rtl">{vacatoinTimeShow(obj,"end_time")}</td>
           <td dir="rtl">{vacatoinTimeShow(obj,"start_time")}</td> 
           <td dir="rtl">{obj.employee ? handleGetFullEmpName(obj.employee) : "لم يتم تحديد الاسم بعد"}</td>
           <td dir="rtl">{obj.employee?.job_id}</td>
        </tr>

            )
          )}
        </tbody>

    </table>

    {
     ( showMore ) &&
      (<div className='showMore_btn_cover'>
         <button className='showMore_btn' onClick={()=>{handleShowMoreClicked()}} dir='rtl'>عرض المزيد...</button>
       </div>)
    }


    </div>

    <ModalCompManagerVacations isOpen={modalIsOpen} closeFun={closeModal} data={modalData}/>


    </div>
  )
}

export default ShowManagerVacationsComp;